import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "count" }

import { RcCounterBadgeProps } from './types';
import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'RcCounterBadge',
  props: {
    count: {},
    type: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const displayCount = computed(() => props.count < 1000 ? props.count : '999+');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rc-counter-badge", {[props.type]: true, disabled: props.disabled}]),
    "data-testid": "rc-counter-badge"
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(displayCount.value), 1)
  ], 2))
}
}

})